// src/api/productDetailApi.js
import { GENERAL_DETAIL_PAGE_URL, COMPLETE_THE_LOOK_URL } from "../config/apiConfig";
const API_URL = GENERAL_DETAIL_PAGE_URL;

export const fetchProductDetail = async (productId, customerId) => {
   
  if (!productId || !customerId) {
    throw new Error("Both productId and customerId are required");
  }

 

  const response = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    
    },
    body: JSON.stringify({
      product_id: productId,
      visitor_id: customerId,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

export const fetchCompleteTheLook = async (customerId, articleId) => {
  try {
    const response = await fetch(
      COMPLETE_THE_LOOK_URL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_id: customerId,
          article_id: articleId,
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Complete the Look API Error: ${response.status} - ${errorText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch Complete the Look:", error);
    throw error;
  }
};

/**
 * Map Complete the Look API response to a consistent format
 * @param {Object} apiResponse - Raw API response
 * @returns {Object} - Formatted recommendations
 */
export const formatCompleteTheLookData = (apiResponse) => {
  if (!apiResponse || !apiResponse.recommendations) {
    return { mainItem: null, recommendations: [] };
  }

  return {
    mainItem: apiResponse.main_item || null,
    recommendations: apiResponse.recommendations.map((item) => ({
      id: item.article_id,
      name: item.prod_name,
      productGroup: item.product_group_name,
      productType: item.product_type_name,
      color: item.perceived_colour_value_name,
      price: parseFloat(item.price || 0),
      image: item.image_url,
      personalizedBoost: item.personalized_boost || 0,
      score: item.score || 0,
      styleMatch: item.style_match || false,
    })),
  };
};